import { useQuery, useMutation } from "@tanstack/react-query";
import { deargenApi } from "@/services/api";
import type {
  DeargenCompoundIdentificationRequest,
  DeargenCompoundIdentificationResponse,
  DeargenHazardAssessmentRequest,
  DeargenHazardAssessmentResponse,
  DeargenHealthResponse,
  DeargenModelInfo,
} from "@/types";

/** AI 서비스 모델 정보 조회 */
export function useModelInfo() {
  return useQuery<DeargenModelInfo>({
    queryKey: ["ai", "model-info"],
    queryFn: () => deargenApi.getModelInfo().then((res) => res.data),
    staleTime: 5 * 60 * 1000,
  });
}

/** AI 서비스 헬스 체크 (30초 간격 자동 갱신) */
export function useAIHealth() {
  return useQuery<DeargenHealthResponse>({
    queryKey: ["ai", "health"],
    queryFn: () => deargenApi.checkHealth().then((res) => res.data),
    refetchInterval: 30000,
  });
}

/** 화합물 동정 뮤테이션 */
export function useCompoundIdentification() {
  return useMutation<
    DeargenCompoundIdentificationResponse,
    Error,
    DeargenCompoundIdentificationRequest
  >({
    mutationFn: (data) =>
      deargenApi.identifyCompounds(data).then((res) => res.data),
  });
}

/** 위해성 평가 뮤테이션 */
export function useHazardAssessment() {
  return useMutation<
    DeargenHazardAssessmentResponse,
    Error,
    DeargenHazardAssessmentRequest
  >({
    mutationFn: (data) =>
      deargenApi.assessHazards(data).then((res) => res.data),
  });
}
